/**
 * Launch deadline for the countdown above the price card.
 *
 * Set FIXED_DEADLINE to an ISO date to close the launch price on a fixed date.
 * Otherwise the countdown starts at 22 h 15 min 30 s from the first visit and
 * is stored in sessionStorage so reloading does not restart it.
 */
const FIXED_DEADLINE: string | null = null

const START_MS = (22 * 3600 + 15 * 60 + 30) * 1000
const STORAGE_KEY = 'volleyball360-offer-deadline'

export function getOfferDeadline(): string {
  if (FIXED_DEADLINE) return FIXED_DEADLINE

  const fresh = new Date(Date.now() + START_MS).toISOString()
  if (typeof window === 'undefined') return fresh

  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY)
    if (stored && new Date(stored).getTime() > Date.now()) return stored
    window.sessionStorage.setItem(STORAGE_KEY, fresh)
  } catch {
    // sessionStorage blocked: the countdown simply restarts on reload.
  }

  return fresh
}

/** Share of launch spots already taken. */
export const spotsTakenPercent = 65
